export default "__VITE_ASSET__Ch6tCiQD__"